import JobApplicants from './JobApplicants';

export default JobApplicants;
